<template lang="html">
  <div :class="`sub-category ${isFetching ? 'fetching' : ''}`">
    <div ref="combos" class="sell-categories-combos py-4">
      <template v-for="(group, index) in subCategoriesGroups">
        <div :key="'subCat-' + index"
             :class="`combo-container px-4 d-sm-inline-block mx-auto my-3 my-sm-0 ${index === activeCat ? 'current' : 'hidden'}`">
          <GroupSelect
            :class="`sub-category-combo ${index === activeCat ? 'current' : 'hidden'}`"
            :items="group"
            @selected="fetchSubCategory($event, index)" />
        </div>
      </template>
    </div>
    <div class="mx-auto text-center">
      <SquaredButton
        class="d-none d-sm-inline-block"
        @click="handleRoot"
        styleType="link"
        label="Regresar" />
      <SquaredButton
        class="d-inline-block d-sm-none"
        @click="handleBack"
        styleType="link"
        label="Regresar" />
      <SquaredButton
        v-show="finalCategory"
        @click="handleNext"
        styleType="primary"
        label="Siguiente" />
    </div>
    <Loading :active="isFetching" />
  </div>

</template>

<script>
import GroupSelect from '@/components/ui/forms/GroupSelect'
import {urls, api} from '@/api'

export default {
  components: {
    GroupSelect
  },

  props: {
    root: String,
    doneCategory: Boolean
  },

  data: () => ({
    subCategoriesGroups: [],
    finalCategory: null,
    isFetching: false,
    activeCat: 0
  }),

  watch: {
    root (id) {
      if (id !== 'manual' && !this.doneCategory) {
        this.subCategoriesGroups = []
        this.finalCategory = null

        if (id) this.fetchSubCategory(id)
      }
    }
  },

  methods: {
    fetchSubCategory (id, index) {
      if (index >= 0) {
        const subCatCount = this.subCategoriesGroups.length
        for (let i = index + 1; i < subCatCount; i++) {
          this.subCategoriesGroups.pop()
        }
      }

      const params = { category_id: id }
      this.isFetching = true

      api.get(urls.sellCategories, { params })
        .then(({data}) => {
          const children = data.data[0].children_categories
          const accPaths = data.data[0].path_from_root.length

          if (children) {
            if (index >= 0) {
              this.activeCat = index + 1
            }
            this.finalCategory = null
            // this avoid duplication when click previous subcategory
            this.subCategoriesGroups = this.subCategoriesGroups.slice(0, accPaths - 1)
            this.subCategoriesGroups.push(children)
            this.scrollNext()
          } else {
            this.finalCategory = data.data[0]
          }
        })
        .finally(() => { this.isFetching = false })
    },

    handleRoot () {
      this.finalCategory = null
      this.activeCat = 0
      this.$emit('return')
    },

    handleBack () {
      this.finalCategory = null
      if (this.activeCat === 0) {
        this.activeCat = 0
        this.$emit('return')
      } else {
        this.activeCat -= 1
        this.subCategoriesGroups.pop()
      }
    },

    handleNext () {
      this.$emit('selected', this.finalCategory)
      this.activeCat = 0
    },

    scrollNext () {
      setTimeout(() => {
        const cont = this.$refs.combos
        cont.scrollLeft = cont.scrollWidth
      }, 100)
    }
  }
}
</script>

<style lang="scss">
  @import '../../scss/breakpoints';

  .sub-category {
    min-height: 50vh;
    display: flex;
    flex-direction: column;

    &-combo {
      & .list-group, & > .form-group > select {
        min-height: 240px;
      }
    }

    @media screen and (max-width: map-get($grid-breakpoints, "sm")) {
      &-combo {
        & .list-group, & > .form-group > select {
          height: fit-content;
          min-height: 150px;
        }
      }
    }
  }

  .fetching {
    cursor: progress !important;
  }

  .sell-categories-combos {
    overflow-x: auto;
    width: 100%;
    white-space: nowrap;
    flex: 1 0 auto;

    & .combo-container {
      width: 18rem;
      // display: inline-block;

      @media screen and (max-width: map-get($grid-breakpoints, "sm")) {
        width: 100%;

        &.hidden {
          display: none !important;
        }

        &.current {
          display: inline-block;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/sellPage/SubCategories.vue